/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * @description Map to each table field its interface
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.0
 */

export interface IPersonalAccount {
    accountBisId: number;
    accountName: string;
    assistantCampaignsCount: number;
    balance: {
        value: number;
        date: number;
    };
    checked: boolean;
    fastActionChecked?: boolean;
    contract: string;
    coordinatorCampaignsCount: number;
    id: number;
    kpp: string;
    loyaltyBonusBalance: {
        value: number;
        date: number;
    };
    loyaltyStatus: string;
    name: string;
    number: string;
    persDataHintCode?: string;
    persDataLockDate: number;
    persDataStatusName: string;
    regionName: string;
    serviceType: object;
    subsCount: number;
    unpaidBillsCount: number;
}

/**
 * @description Describe personal account table column
 * @interface PersonalAccountField
 */
export enum PersonalAccountField {
    assistantCampaignsCount = 'assistantCampaignsCount',
    balance = 'balance',
    coordinatorCampaignsCount = 'coordinatorCampaignsCount',
    contract = 'contract',
    inn = 'inn',
    kpp = 'kpp',
    loyaltyBonusBalance = 'loyaltyBonusBalance',
    loyaltyStatus = 'loyaltyStatus',
    name = 'name',
    number = 'number',
    persDataLockDate = 'persDataLockDate',
    persDataStatusName = 'persDataStatusName',
    regionName = 'regionName',
    subdivisionKpp = 'subdivisionKpp',
    subdivisionName = 'subdivisionName',
    subsCount = 'subsCount',
    unpaidBillsCount = 'unpaidBillsCount',
}

export const personalAccountColumnNames: PersonalAccountField[] = [
    PersonalAccountField.number,
    PersonalAccountField.assistantCampaignsCount,
    PersonalAccountField.balance,
    PersonalAccountField.contract,
    PersonalAccountField.coordinatorCampaignsCount,
    PersonalAccountField.kpp,
    PersonalAccountField.loyaltyBonusBalance,
    PersonalAccountField.loyaltyStatus,
    PersonalAccountField.name,
    PersonalAccountField.persDataLockDate,
    PersonalAccountField.persDataStatusName,
    PersonalAccountField.regionName,
    PersonalAccountField.subdivisionKpp,
    PersonalAccountField.subdivisionName,
    PersonalAccountField.subsCount,
    PersonalAccountField.unpaidBillsCount,
];
